import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid } from '@mui/material';
import { PageContainer, FilterPod, TableComponents, ButtonLoading, SimpleDialog } from 'components';
import useCustomHook from './hooks';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { columns, generateData } from './components/Columns';
import SubsetServices from '../../Subsets/services/SubsetServices';
import Services from '../services';
import { useStyles } from './style';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';

export default function CartableList() {
  //-- STATES --//
  let tableRef = useRef();
  const {
    loading,
    setLoading,
    setFilterParams,
    size,
    setSize,
    filters,
    setFilters,
    loadingBtn,
    setLoadingBtn,
    dialog,
    setDialog,
    page,
    setPage,
    creditList,
    setCreditList,
  } = useCustomHook();

  //--HOOKS--//
  const classes = useStyles();
  const actionsList =
    getDynamicObjectAction([
      'contentCartblePage',
      'contentListCartbleBtn',
      'contentRequestCartblePage'
    ])
  const navigate = useNavigate();
  useEffect(() => {
    if (actionsList['contentCartblePage']) {
      getCredit();
    }
  }, []);

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  const getCredit = async () => {
    try {
      const result = await Services.getCredit();
      const cartablist = [
        ...result.mainBusinessAmountSrvs.filter((a) => a),
        ...result.customerAmountSrvs.filter((a) => a),
      ];
      let list = [];
      list = cartablist.map((val) => ({
        name: val?.guildSrv ? val?.guildSrv?.name : val?.walletName,
        label: val?.guildSrv ? val?.guildSrv?.name : val?.walletName,
        value: val?.guildSrv ? val?.guildSrv?.code : val?.wallet,
        id: val?.guildSrv ? val?.guildSrv?.code : val?.wallet,
        wallet: val?.wallet,
        guild: val?.guildSrv,
      }));
      setCreditList(list);
    } catch (error) {
      return [];
    }
  };
  //--API REQUESTS--//
  const getBranchesList = async (query) => {
    try {
      setLoading(true);
      let filter = toFilterVOS([...filters]);
      let queries = filterVOStoQueryStr(filter);

      var params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };
      if (creditList) {
        let result = creditList.filter((d) => {
          return d.value === queries?.query;
        });
        if (result && result[0]?.wallet) {
          params['wallet'] = result[0]?.value;
        } else if (result && result[0]?.guild) {
          params['guildCode'] = result[0]?.value;
        }
      }

      const data = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };

      setFilterParams({ data, params });

      const res = await Services.getCarTableList(params);

      let list = [];

      list = generateData(res?.result, {
        page: query ? query?.pageNumber : page,
        pageSize: query?.pageSize || size,
      });
      setLoading(false);

      let d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; //passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const changeStateOfBranch = async (selectedRow, changeStatusGroup) => {
    setLoadingBtn(true);

    try {
      if (Array.isArray(selectedRow)) {
        const filterBaseOnSameState = selectedRow.filter(
          (row) => row.branchInfoSrv.enable !== changeStatusGroup,
        );

        if (filterBaseOnSameState.length) {
          await SubsetServices.changeStateOfBranch({
            branchId: filterBaseOnSameState.map((row) => row.id),
            enable: changeStatusGroup,
          });
        }
      } else {
        await SubsetServices.changeStateOfBranch({
          branchId: [selectedRow.id],
          enable: !selectedRow.branchInfoSrv.enable,
        });
      }
      setTimeout(() => {
        tableRef?.current?.onChangeTable();
      }, 100);
    } catch (error) {
    } finally {
      setLoadingBtn(false);
      handleCloseDialog();
    }
  };

  //-- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
    setSize(10);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
  };

  const handleCloseDialog = () => {
    setDialog({ title: '', content: '', open: false, onAccept: () => null });
  };

  const ChangeStateActionBtn = () => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={loadingBtn}
          name="بله"
          onClick={dialog?.onAccept}
        />

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
      </>
    );
  };

  const ChangeStateGroupActionBtn = () => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={loadingBtn}
          name="فعال‌سازی"
          onClick={() => changeStateOfBranch(dialog.data, true)}
        />

        <ButtonLoading
          type="submit"
          variant="outlined"
          color="primary"
          loading={loadingBtn}
          name="غیرفعال‌سازی"
          onClick={() => changeStateOfBranch(dialog.data, false)}
        />

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
      </>
    );
  };


  const hint = 'در این بخش میتوانید لیست حساب های چند امضایی را مشاهده کنید.';

  return (
    <PageContainer
      title="لیست حساب ها"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.CARTABLE_LIST}
      className={classes.root}
    >
      {actionsList['contentCartblePage'] && (
        <>
          <Grid item xs={12}>
            <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
              <FilterButton
                setOpenFilterDialog={setOpenFilterDialog}
                filters={filters}
              />
            </Box>
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          </Grid>
          <TableComponents
            data={getBranchesList}
            columns={columns(navigate, setDialog, changeStateOfBranch, actionsList)}
            isLoading={loading}
            ref={tableRef}
            onChange={(ps) => {
              setPage(ps?.pageNumber);
              setSize(ps?.pageSize);
              return getBranchesList(ps);
            }}
          />
        </>
      )}
      {
        dialog.type === 'ChangeStateActionBtn' && (
          <SimpleDialog
            title={dialog?.title}
            content={dialog?.content}
            open={dialog?.open || false}
            actions={<ChangeStateActionBtn />}
          />
        )
      }

      {
        dialog.type === 'ChangeStateGroupActionBtn' && (
          <SimpleDialog
            title={dialog?.title}
            content={dialog?.content}
            open={dialog?.open || false}
            actions={<ChangeStateGroupActionBtn />}
          />
        )
      }
    </PageContainer >
  );
}
